





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import MomentOfferedStatListComponent from '@/components/MomentOfferedStatListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { TokenUser } from '@/TokenUser'
import { MomentOfferedStat } from '@/MomentOfferedStat'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'

let USE_SOCKET_IO: boolean = false
const STOP_AFTER_X_CONSECUTIVE_ERRORS: number = 2

@Component({
  name: 'HighestSpreadOffers',
  components: { MomentOfferedStatListComponent, ModalWrapperComponent }
})

export default class HighestSpreadOffersComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentOfferedStat[] = []
  public paginationResult: IPaginationResult = null

  // UI and filter options

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public showFAQ(): void {
    (this.$refs.FAQHighestSpreadsComponent as ModalWrapperComponent).show('Highest Spreads FAQ', 'md', null)
  }

  public generateKey(moment: MomentOfferedStat): string {
    return moment.generateKey()
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean = true
  private numErrorsInARow: number = 0
  private pageNumberToLoadNext: number = 1

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    // for header
    const fakeMoment: MomentOfferedStat = new MomentOfferedStat(null)
    fakeMoment.setID = 0

    this.lastFetchSucceeded = false

    let url: string = utils.getURLprefix() + `/api/topshot/HighestSpreadOffers?`
      url += `&filter=1`;
      url += `&page=${pageNumberWhenCalled}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`HighestSpreadOffersComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    
    try {
      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        this.numErrorsInARow++
        if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) utils.toast(this, 'Error', response.data.error)
        return
      }

      // moments
      if (response.data.hsfo) {

        // pagination result
        this.paginationResult = response.data.paginationResult

        // load up the moments separately from the MPListings object in case we want to do paging (might do everything inside MPListings eventually)
        let newRawItems: MomentOfferedStat[] = response.data.hsfo.moments
        if (newRawItems) {
          newRawItems = newRawItems.map((po) => new MomentOfferedStat(po));
          if (pageNumberWhenCalled === 1) this.moments = [ fakeMoment ].concat(newRawItems);
          else this.moments = this.moments.concat(newRawItems)

          // tell MomentOfferedStatListComponent which columns to show
          fakeMoment.setForLargestSpreadEditions()
          for (const m of newRawItems) m.setForLargestSpreadEditions()

          this.pageNumberToLoadNext++
          this.lastFetchSucceeded = true

          return newRawItems.length
        } else {
          this.lastFetchSucceeded = false;
          return 0
        }
      } else {
        this.paginationResult = null
        this.moments = []
      }

      this.lastFetchSucceeded = true
      this.numErrorsInARow = 0

    } catch (error) {
      if (this.$store.state.devmode) console.log(error);
      this.numErrorsInARow++
      if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

  }  
}
